import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <TopicsSection />
        <CarouselSection />
        <CardsSection />
        <CommentsSection />
        <FaqSection />
        <RankingSection />
        <ContactSection />
        <AboutSection />
        <UpdatesSection />
        <MediaSection />
        <IndexSection />
        <FeaturesSection />
      </main>

      <Footer />
    </div>
  );
}